module.exports = __webpack_public_path__ + "static/competition-2-9f554819520eda567e934a4fed3d5bee.svg";